import { gql } from 'apollo-angular';
import { Group } from '../../entities/group/group';
import { Role } from '../../entities/role/role';


export const GROUP_QUERY = gql`
query getGroupQuery(
  $id: String
)
{
  group: getGroup(
    id: $id
  )
  {
    id
    name
    roles
  },
  roles: getRoles {
    name
    label
  }
}
`;

export interface GroupQueryResponse {
  group: Group;
  roles: Role[];
  loading: boolean;
}
